import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UsersRound } from 'lucide-react';
import { getMyPersonnel } from '../../../services/dashboardService';
import { Card, CardHeader, CardTitle, CardBadge, ListItem, Avatar, ListItemContent, ListItemName, ListItemSub, EmptyState, ScrollList } from '../styles';

export default function PersonnelCard() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    getMyPersonnel().then(res => {
      const d = res.data?.data;
      setItems(Array.isArray(d) ? d : []);
    });
  }, []);

  return (
    <Card $grow={3} $minWidth="240px" $delay="0.35s">
      <CardHeader>
        <CardTitle>{t('dashboard.myPersonnel')}</CardTitle>
        {items.length > 0 && <CardBadge>{items.length}</CardBadge>}
      </CardHeader>
      {items.length === 0 ? (
        <EmptyState>
          <UsersRound size={32} />
          {t('dashboard.noPersonnel')}
        </EmptyState>
      ) : (
        <ScrollList>
          {items.map(item => {
            const initials = item.fullName?.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
            return (
              <ListItem key={item.userId}>
                <Avatar>
                  {item.profilePicture ? <img src={item.profilePicture} alt="" /> : initials}
                </Avatar>
                <ListItemContent>
                  <ListItemName>{item.fullName}</ListItemName>
                  {item.titleName && <ListItemSub>{item.titleName}</ListItemSub>}
                </ListItemContent>
              </ListItem>
            );
          })}
        </ScrollList>
      )}
    </Card>
  );
}
